<template>
  <div class="backEndHome">
    <el-container class="home-container">
      <el-container>
        <!-- 左侧边栏 -->
        <el-aside class="leftMain">
          <el-aside class="left1" ref="asideLeft" >
            <!-- 左侧图标 -->
            <div class="left-logo">
              <router-link to="/">
                <img src="../../../public/img/logo.png" alt>
              </router-link>
            </div>
          </el-aside>
           <el-aside class="left" ref="asideLeft">
            <div v-for="(item,index) in leftList" :key="index">
              <el-menu class="el-menu-vertical-demo" :default-active="getRoute" @open="handleOpen" @close="handleClose"  collapse-transition unique-opened router>
               <!-- 一级 -->
                <el-submenu :index="index+''" >
                  <template slot="title">
                    <img style="margin-right:8px;" :src="item.img" alt="">
                    <span slot="title">{{item.name}}</span>
                  </template>
                  <!-- 二级 -->
                  <div v-for="(item2,index2) in item.child" :key="index2">
                    <el-menu-item :index="item2.path" >
                      <img style="margin-right:8px;" :src="item2.img" alt="">
                      <span slot="title">{{item2.name}}</span>
                    </el-menu-item>
                  </div>
                </el-submenu>
              </el-menu>
            </div>
          </el-aside>
        </el-aside>

        <!-- 主要区域容器 -->
        <el-container>
          <!-- 头部区域 -->
          <el-header class="main-header">
            <div class="main-header-logo">
              <div class="backEnd-title">渔联网后台管理</div>
            </div>
            <div class="main-header-box">
              <div class="main-header-box-two">
                <img v-if="loginUser.photoUrl" :src="getImgUrl(loginUser.photoUrl)" alt>
                <img v-else src="../../../public/img/user_img.png" alt>
                <span class="el-dropdown-link">{{loginUser.nickName}}</span>
              </div>
              <span @click="logout" style="cursor:pointer">退出</span>
            </div>
          </el-header>
          <el-main class="main">
            <router-view style="border-radius:4px;"></router-view>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
    <iframe :src="loginout" hidden></iframe>
  </div>
</template>

<script>
import api from "../../service/api.js";
import url from "../../service/base-url";
import { mapActions, mapState, mapGetters } from "vuex";
import { modules } from "../../store";
import checkPermission from "../../service/checkPermission.js";
export default {
  name: "backEndHome",
  data() {
    return {
      baseList: [],
      leftList: [
        {
          name: "渔联网",
          img: require("../../assets/images/qualityTracing/icon_zhiliangzhuisu.png"),
          child: [
            {
              name: "设备列表",
              img: require("../../assets/images/qualityTracing/icon_zhiliangzhuisu2.png"),
              path: "/backStage"
            },
            {
              name: "公司管理",
              img: require("../../assets/images/qualityTracing/icon_zhiliangzhuisu2.png"),
              path: "/companyManage"
            },
            {
              name: "用户管理",
              img: require("../../assets/images/qualityTracing/icon_zhiliangzhuisu2.png"),
              path: "/userManage"
            },
            {
              name: "提现设置",
              img: require("../../assets/images/qualityTracing/icon_zhiliangzhuisu2.png"),
              path: "/withManage"
            }
          ]
        }
      ],
      loginout: ""
    };
  },
  methods: {
    getImgUrl(name) {
      // 拼接url
      if (!name) {
        return "";
      } else {
        return url.nxinFileUrl + name;
      }
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},

    async login() {
      await api.get(`${url.base}/api/account/checkauth`);
    },
    //退出
    async logout() {
      try {
        this.loginout = `${url.base}/api/account/logout`;
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    }
  },
  async mounted() {
    if (this.$route.path == "/backEnd/addQualityTracing") {
      this.leftList[0].child[0].path = "/backEnd";
    }
  },
  computed: {
    ...mapState(["loginUser"]),
    // 返回激活 的导航 ，赋予颜色
    getRoute() {
      if (this.$route.path == "/backEnd/addQualityTracing") {
        return "/backEnd";
      } else if (
        this.$route.path == "/backEnd/qualityCheckManage/addQualityCheck" ||
        this.$route.path == "/backEnd/qualityCheckManage/editQualityCheck"
      ) {
        return "/backEnd/qualityCheckManage";
      } else if (
        this.$route.path == "/backEnd/driverManage/addDriver" ||
        this.$route.path == "/backEnd/driverManage/editDriver"
      ) {
        return "/backEnd/driverManage";
      } else if (
        this.$route.path ==
          "/backEnd/circulationBusinessManage/addCirculationBusiness" ||
        this.$route.path ==
          "/backEnd/circulationBusinessManage/editCirculationBusiness"
      ) {
        return "/backEnd/circulationBusinessManage";
      } else {
        return this.$route.path;
      }
    }
  }
};
</script>
<style lang="stylus">

.backEndHome
  
  .place
    .el-input__prefix
      left: 100px;
      font-size:16px;
      color:#999;
      .el-icon-date:before
        position absolute;
        content: "";
        top:13px;
        width: 18px;
        height: 19px;
        background: url(../../assets/images/qualityTracing/icon_calendar.png) no-repeat 97% center;
        background-size: 18px 19px;
    .el-input__inner
      padding-left:15px;
  .select-container-box 
    >span 
      margin-right:10px;
  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:#999;
    font-size :14px;
  }
  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color:#999;
    font-size :14px;
  }
  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color:#999;
    font-size :14px;
  }
  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color:#999;
    font-size :14px;
  }
  .el-upload-list--picture-card .el-upload-list__item,.el-upload--picture-card
    width:160px;
    height:148px;
  .el-icon-plus
    position relative
    display block
    width:160px;
    height:148px;
    .upload-tip
      min-width 130px;
      text-align center;
      position absolute;
      top:55%;
      font-size:14px;
      padding:0 15px;
      line-height 1.4;
  .el-icon-plus:before
    position absolute;
    content: "";
    top:30%;
    left 50%;
    margin-top:-24px;
    margin-left:-24px;
    width: 48px;
    height: 48px;
    background: url(../../assets/images/qualityTracing/input_add.png) no-repeat center center;
    background-size: 48px 48px;
  .save-cancel
    // padding:20px 0 40px 0;
    .el-button
      width:140px;
    .cancel-btn
      margin-left:20px;
      border:1px solid #aeaeae;
  .el-icon-arrow-up:before 
    color:#666;
  .el-form-item__label
    position relative;
    text-align:right!important;
    font-size 16px;
    color:#666!important;
    padding:0 20px 0 0;
  .el-form
    margin-left:120px;

  .home-container
    .main
      background #eee !important ;
  .content-del
    margin-left 20px !important ;
  .el-button
    font-size 14px;
  .title-container{
    background #f7f7f7;
  }
  .title-container,.titleForm-container
    height 54px !important;
    line-height 54px !important;
  
  .el-icon-arrow-down
    width 10px;
    height 6px;
    display block
  .el-icon-arrow-down:before 
    position absolute;
    top:0px;
    content: "";
    width: 10px;
    height: 6px;
    background: url(../../assets/images/qualityTracing/arrow_down.png) no-repeat 97% center;
    background-size: 10px 6px;
  .el-submenu__title i {
    color: #909399;
  }
  .el-submenu__icon-arrow{
    margin-top:-3px;
  }
  .el-submenu__title
    span 
      font-family:MicrosoftYaHei;
      color:#333;
      font-size:16px;
  .el-menu-item
    font-size:15px;
    font-family:MicrosoftYaHei;
    color:#565656;
    span
      font-size:16px;
  .el-menu-item.is-active 
    color: #565656;
    background:#c3e3ff;
  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before
    position absolute
    content: '*';
    color: #FE3223;
    margin-top:2px;
    vertical-align:middle;
    margin-left: -10px;
    font-size: 18px;
  .el-main 
    padding:10px;
  .el-input--medium .el-input__inner
    height 44px;
    line-height:44px;
    color:#333;
  .table-container
    // padding 33px 29px 29px 29px;
    padding:10px 9px;
  .table-container .el-table .el-table__header th .cell 
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    color: #666;
    font-weight: bold;
    line-height: 36px;
</style>


<style lang="stylus" >
body >, .el-container {
  margin-bottom: 40px;
}

.backEndHome {
  height: 100%;

  .home-container {
    height: 100%;

    .leftMain {
      width: 210px !important;

      &.isActive {
        width: 64px !important;
      }

      // 左侧侧边栏
      .left1 {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 210px !important;
        border-right: 1px solid #e0e0e0;
        background-color: #fff;

        &.isActive {
          width: 64px !important;
        }

        .left-logo {
          height: 82px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          border-bottom 1px solid #DDDDDD

          img {
            cursor: pointer;
          }
        }
      }

      .left {
        margin-top: 82px;
        height: 91%;
        width: 210px !important;
        border-right: 1px solid #e0e0e0;
        background-color: #fff;

        &.isActive {
          width: 64px !important;
        }

        .el-menu-vertical-demo {
          border-right: none;
        }
      }
    }

    .main-header {
      display: flex;
      align-items: center;
      height: 54px !important;
      line-height: 54px !important;
      background: rgba(255, 255, 255, 1);
      border-bottom: 1px solid #ddd;

      .main-header-logo {
        flex: 1;
        display: flex;

        .main-header-logo-one, .main-header-logo-two {
          >img {
            cursor: pointer;
          }
        }

        .main-header-logo-two {
          >img {
            margin-right: 3.4vh;
          }
        }

        .backEnd-title {
          margin-left: 10px;
          font-size: 20px;
          font-family: MicrosoftYaHei-Bold;
          font-weight: bold;
          color: rgba(51, 137, 255, 1);
        }
      }

      .main-header-box {
        display: flex;
        align-items: center;
        margin-right:15px;
      }

      .main-header-box-one {
        display: flex;
        border: 1px solid rgba(221, 221, 221, 1);
        border-bottom: none;
        border-top: none;
        margin-right: 40px;

        >li {
          width: 90px;
          text-align: center;
          cursor: pointer;
        }

        .li img {
          display: none;
          position: absolute;
          top: 80px;
          right: 0px;
          width: 100px;
          height: 100px;
        }

        .li:hover img {
          display: block;
          position: absolute;
          z-index: 2;
          top: 60px;
          right: 304px;
          width: 100px;
          height: 100px;
        }
      }

      .main-header-box-two {
        margin: 0 10px 0 -10px;

        >img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
          vertical-align: middle;
          cursor: pointer;
          margin-top:-2px;
          border-radius: 25px;
        }

        .el-dropdown-link {
          color: #3389ff;
          margin-right: 10px;
        }
      }
    }

    // 主体容器
    .main {
      background: #F2F3F6;
      color: #3333;
    }

    // 主体底部
    .footer {
      color: #333;
      text-align: center;
      line-height: 60px;
    }
  }
}
</style>
